import { render, staticRenderFns } from "./valueAssessmentNew.vue?vue&type=template&id=02a53677&scoped=true"
import script from "./valueAssessmentNew.vue?vue&type=script&lang=js"
export * from "./valueAssessmentNew.vue?vue&type=script&lang=js"
import style0 from "./valueAssessmentNew.vue?vue&type=style&index=0&id=02a53677&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a53677",
  null
  
)

export default component.exports